<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isSubMenu: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { icon, title, isSubMenu } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(
          h('i', {
            class: [icon, 'sub-el-icon']
          })
        )
      } else {
        if (icon !== '#') {
          vnodes.push(
            h('img', {
              attrs: {
                src: require(`@/icons/svg/${icon}.svg`)
              },
              style: {
                verticalAlign: 'middle',
                width: '20px',
                height: '20px',
                marginRight: '5px',
                filter: 'brightness(0) invert(1)'
              }
            })
          )
        }
      }
    }

    if (title) {
      vnodes.push(
        h(
          'span',
          {
            slot: 'title',
            style: {
              marginLeft: icon === '#' && isSubMenu ? '25px' : '0',
              paddingLeft: '0'
            }
          },
          title
        )
      )
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>
